import { FACET_NAMES, FILTER_ORDER, WHITE_LISTED_FACETS, } from '../../constants/templateGrid';
const _toTitleCase = (str) => str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
const _sanitizeFilterName = (name) => _toTitleCase(name.split('_').join(' ').trim());
const _createFilter = (name, collapsed, count, filters = [], key, value) => ({
    name: name === FACET_NAMES.d ? name : _sanitizeFilterName(name),
    collapsed,
    count,
    filters,
    enabled: true,
    key: key ?? name,
    selected: false,
    value: value ?? [],
});
const _convertFacetToFilters = (facet, isIndustry) => Object.keys(facet).map((facetKey) => {
    return _createFilter(facetKey, null, facet[facetKey]);
});
const _getTotalTemplateCountForFilter = (filters) => filters.reduce((prev, current) => (!current.count ? prev : prev + current.count), 0);
const _whiteListFilters = (filters, filterKey) => {
    const whiteList = WHITE_LISTED_FACETS[filterKey] ?? [];
    return filters.filter(filter => whiteList.includes(filter.key.toLowerCase()));
};
const _sortFilters = (filters) => {
    return filters.sort((a, b) => (b?.count ?? 0) - (a?.count ?? 0));
};
const _replaceFilterName = (filters, filterKey) => {
    if (filterKey !== 'd')
        return filters;
    return filters.map(filter => {
        return {
            ...filter,
            name: filter.key === '16:9'
                ? 'Landscape'
                : filter.key === '1:1'
                    ? 'Square'
                    : filter.key === '9:16'
                        ? 'Portrait'
                        : '',
        };
    });
};
export const getTemplateFilters = (facets) => {
    if (!facets)
        return [];
    const filters = FILTER_ORDER.reduce((prev, current) => {
        const filterName = FACET_NAMES[current];
        const facetToProcess = facets[current];
        if (!filterName || !facetToProcess) {
            return prev;
        }
        let childFilters = _convertFacetToFilters(facetToProcess, filterName === FACET_NAMES[current]);
        childFilters = _whiteListFilters(childFilters, current);
        childFilters = _sortFilters(childFilters);
        childFilters = _replaceFilterName(childFilters, current);
        const count = _getTotalTemplateCountForFilter(childFilters);
        return [
            ...prev,
            _createFilter(filterName, false, count, childFilters, current),
        ];
    }, []);
    return filters;
};
